import React, { useEffect } from "react";
import TextHeader from "./TextHeader/TextHeader";
import TextBody from "./TextBody/TextBody";
import useEfficeNav from "./useEfficeNav/useEfficeNav";
import { isFreshman, startInEfficeHelpers } from "helpers/freshman";
import { useSelector } from "react-redux";
import { selectCurrentAppId } from "slices/sharedSelectors";
let getState = null;
import("Store").then((module) => {
  getState = module.store.getState;
});

const Text = () => {
  window.efs_debug && window.log("TEXT RENDERED");
  const currentAppId = useSelector(selectCurrentAppId);

  useEfficeNav();

  useEffect(() => {
    let intTimeout = null;
    if (isFreshman()) {
      intTimeout = setTimeout(() => {
        if (!getState().spaceMedia.spaceBoxActive) startInEfficeHelpers();
      }, 2000);
    }

    return () => {
      if (intTimeout) clearTimeout(intTimeout);
    };
  }, []);

  return (
    <>
      <TextHeader currentAppId={currentAppId} />
      <div className="Txt-body">
        <TextBody currentAppId={currentAppId} />
      </div>
    </>
  );
};

export default Text;
